<template>
  <div class="site-connect-additional-content-intro">
    <h1 class="site-connect-additional-content-intro__heading">
      {{ headline }}
    </h1>
    <BenefitItemList :items="benefits" />
  </div>
</template>
<script lang="ts" setup>
import BenefitItemList from '@/components/molecules/benefit-item-list/BenefitItemList.vue'
import type { SiteConnectAdditionalContentIntroProps } from './site-connect-additional-content.types'
import { computed, type ComputedRef } from 'vue'
import type { BenefitItemListItem } from '@/components/molecules/benefit-item-list/benefit-item-list.types'

const props = defineProps<SiteConnectAdditionalContentIntroProps>()

const benefits: ComputedRef<BenefitItemListItem[]> = computed(() =>
  props.benefits?.map((benefit) => ({
    id: benefit.id,
    icon: benefit.svg,
    text: benefit.text,
    title: benefit.title
  }))
)
</script>
<style lang="scss" scoped>
@import './site-connect-additional-content-intro.scss';
</style>
